interface IndexByAny {
  [key:string]: any,
};

const fastStorage:IndexByAny = {

};

export default fastStorage;
